import React, { Component } from "react";
import Loading from "../components/Loading";
import {
  ScrollView,
  View,
  StyleSheet,
  TouchableHighlight,
  KeyboardAvoidingView,
} from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import { IS_WEB, RIGHT, translate } from "../locales/translate";
import * as AreaHelper from "../actions/AreaHelper";
import { ArButton } from "../argon-ui";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import GuestExpirePicker from "../components/GuestExpirePicker";
import Theme from "../argon-ui/Theme";
import * as Actions from "../actions/UserActions";
import PropTypes from "prop-types";
import roles from "../actions/roleHelper";
import InputSearch from "../components_v2/InputSearch";
import ModalBase from "../nativeBase-ui/ModalBase";
import { HStack } from "native-base";

class UserAccessScreen extends Component {
  constructor(props) {
    super(props);
    // retrieve params from navigator
    this.user = {};

    let { userId, expireDate } = this.props.navigation.state.params;
    var listName = expireDate == null ? "users" : "guests";
    for (var i in this.props.userReducer[listName]) {
      if (this.props.userReducer[listName][i].id == userId) {
        this.user = this.props.userReducer[listName][i];
        break;
      }
    }
    this.state = {
      isLoading: true,
      userId,
      fullName: this.user.fullName || "",
      phoneNumber: this.user.phoneNumber || "",
      userRole: expireDate == null ? "member" : "guest",
      searchTerm: "",
      isAccessModalVisible: false,
      isDeleteModalVisible: false,
      selectedAreaId: -1,
      selectedAreaUId: null,
      selectedAreaName: "",
      accessToken: "",
      showExpirePicker: false,
      expireValue: 1,
      expireUnit: "hour",
    };
    this.model = {};
    this.allAreas = [];
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.UserList"),
  });
  componentDidMount() {
    this.allAreas = [...this.props.areaReducer.areas];
    // if oldAreaId passed, show only related tree.

    var mainAreaIds = [];
    this.allAreas.filter((a) => {
      if (a.isMainArea) mainAreaIds.push(a.areaId || a.areaUId);
    });
    var rootNode = {
      areaId: -1,
      areaName: "",
      subAreas: this.allAreas.filter((a) => {
        let mainArea = AreaHelper.findMainParent(this.allAreas, a) || {};
        if (
          a.isMainArea ||
          mainAreaIds.indexOf(mainArea.areaId || mainArea.areaUId) < 0
        ) {
          mainAreaIds.push(a.areaId || a.areaUId);
          return a.areaId || a.areaUId;
        }
      }),
    };

    this.model = rootNode;

    for (var i in this.props.userReducer.users) {
      if (this.props.userReducer.users[i].id == this.state.userId) {
        this.user = this.props.userReducer.users[i];
        break;
      }
    }
    this.setState({
      isLoading: false,
      accessToken: this.props.appReducer?.currentServer.accessToken,
    });
  }

  toggleAccessModal = (areaId = -1, areaUId = null, areaName = "") => {
    if (this.state.isAccessModalVisible) {
      this.setState({
        isAccessModalVisible: false,
        selectedAreaId: -1,
        selectedAreaUId: null,
        selectedAreaName: "",
        showExpirePicker: false,
        expireValue: 1,
      });
    } else {
      this.setState({
        isAccessModalVisible: true,
        selectedAreaId: areaId,
        selectedAreaUId: areaUId,
        selectedAreaName: areaName,
      });
    }
  };

  handleOnRoleItemPress = (role) => {
    if (role == "guest") {
      this.setState({ showExpirePicker: true });
      return;
    }
    let { userId, selectedAreaId, selectedAreaUId, accessToken } = this.state;
    this.props.SetMemberAccess(
      userId,
      selectedAreaId,
      selectedAreaUId,
      role,
      0,
      "",
      accessToken,
      this.props.appReducer.currentBuilding.buildingId
    );
    this.toggleAccessModal();
  };

  handleNotify = () => {
    this.props.NotifyUserModified(this.user.id, this.state.accessToken);
    this.goBack();
  };
  goBack = () => {
    this.props.navigation.navigate("Users");
  };
  render() {
    if (this.state.isLoading) {
      return <Loading />;
    }
    return (
      <View style={{ flex: 1 }}>
        <ModalBase
          isOpen={this.state.isAccessModalVisible}
          onClose={() => this.toggleAccessModal()}
        >
          <View style={[styles.modalInsideWrapper, { height: "100%" }]}>
            <Text
              style={{
                fontSize: 14,
                marginBottom: 20,
                paddingHorizontal: 5,
              }}
            >
              {translate("user.modifyAccessLevel")}{" "}
              {this.state.selectedAreaName}
            </Text>
            <View style={{ height: "100%", flex: 1 }}>
              <ScrollView style={{ flex: 1 }}>
                {this.state.userRole == "support" && (
                  <RoleItem
                    onPress={(role) => this.handleOnRoleItemPress(role)}
                    role="support"
                  />
                )}
                {this.state.userRole != "guest" && (
                  <RoleItem
                    onPress={(role) => this.handleOnRoleItemPress(role)}
                    role="admin"
                  />
                )}
                {this.state.userRole != "guest" && (
                  <RoleItem
                    onPress={(role) => this.handleOnRoleItemPress(role)}
                    role="member"
                  />
                )}
                <RoleItem
                  onPress={(role) => this.handleOnRoleItemPress(role)}
                  role="guest"
                />
                <RoleItem
                  onPress={(role) => this.handleOnRoleItemPress(role)}
                  role="none"
                />
                {this.state.showExpirePicker && (
                  <View>
                    <GuestExpirePicker
                      expireUnit={this.state.expireUnit}
                      expireValue={this.state.expireValue}
                      onUnitChange={(unit) => {
                        this.setState({ expireUnit: unit });
                      }}
                      expireValueIsValid={this.state.expireValue > 0}
                      onValueChange={(value) => {
                        var _val = Number(value) || 0;
                        console.log(_val);
                        this.setState({
                          expireValue: Math.floor(_val),
                        });
                      }}
                    />
                    <ArButton
                      color="success"
                      style={{
                        marginTop: 5,
                        width: "100%",
                        alignSelf: "center",
                      }}
                      onPress={() => {
                        let {
                          userId,
                          selectedAreaId,
                          selectedAreaUId,
                          accessToken,
                          expireValue,
                          expireUnit,
                        } = this.state;
                        this.props.SetMemberAccess(
                          userId,
                          selectedAreaId,
                          selectedAreaUId,
                          "guest",
                          expireValue,
                          expireUnit,
                          accessToken,
                          this.props.appReducer.currentBuilding.buildingId
                        );
                        this.toggleAccessModal();
                      }}
                    >
                      <Text
                        style={{
                          fontWeight: "bold",
                          fontSize: 14,
                          color: Theme.COLORS.WHITE,
                        }}
                      >
                        {translate("app.confirm")}
                      </Text>
                    </ArButton>
                  </View>
                )}
                {/* <ArButton
                  color="muted"
                  variant="outline"
                  style={{
                    marginTop: 10,
                    marginBottom: 0,
                    width: "100%",
                    alignSelf: "center",
                  }}
                  onPress={this.toggleAccessModal}
                >
                  {translate("app.cancel")}
                </ArButton> */}
              </ScrollView>
            </View>
          </View>
        </ModalBase>
        <KeyboardAvoidingView style={{ flex: 1 }} behavior="height" enabled>
          <View style={{ paddingHorizontal: 10 }}>
            <Text
              style={{ fontSize: 15, fontWeight: "bold", marginVertical: 10 }}
            >
              {translate("user.modifyAccessLevelHeader")}
            </Text>
            <Text style={{ color: Theme.COLORS.MUTED }}>
              {this.state.fullName} - {this.state.phoneNumber}
            </Text>
            <InputSearch
              containerStyle={{ marginVertical: 10 }}
              onChangeText={(txt) => {
                this.setState({
                  searchTerm: txt,
                });
              }}
              value={this.state.searchTerm}
            />
          </View>
          <ScrollView style={{ flex: 1 }}>
            {this.allAreas.length > 0 && (
              <AreaAccessSelectItem
                model={this.model || {}}
                allAreas={[...this.allAreas]}
                allAccess={this.user.areas || []}
                disabled={this.model.areaId <= 0}
                onPress={(areaId) => {
                  // root node always is empty
                  // console.log(areaId , 'cached in top level');
                  // this.setState({ isAccessModalVisible: true });
                }}
                onChildPress={(subArea) => {
                  // subArea is object
                  this.toggleAccessModal(
                    subArea.areaId,
                    subArea.areaUId,
                    subArea.areaName
                  );
                }}
                searchTerm={this.state.searchTerm}
              />
            )}
          </ScrollView>
          <HStack space="2" style={{ paddingHorizontal: 10 }}>
            <ArButton
              color="primary"
              style={{ flex: 1 }}
              onPress={() => this.handleNotify()}
            >
              {translate("user.notifyUserAndExit")}
            </ArButton>
            <ArButton
              variant="outline"
              color="primary"
              style={{ flex: 1 }}
              onPress={() => this.goBack()}
            >
              {translate("app.goBack")}
            </ArButton>
          </HStack>
        </KeyboardAvoidingView>
      </View>
    );
  }
}

class AreaAccessSelectItem extends Component {
  constructor(props) {
    super(props);
    let { icon, iconColor, roleName } = this.updateRole();

    this.state = {
      icon,
      iconColor,
      roleName,
    };
    this.allAreas = [...this.props.allAreas];
  }

  updateRole = () => {
    var icon = roles.icons.none;
    var iconColor = roles.colors.none;
    var roleName = "none";
    for (var i in this.props.allAccess || [{}]) {
      if (this.props.allAccess[i].areaId == this.props.model.areaId) {
        icon = roles.icons[this.props.allAccess[i].accessLevel];
        iconColor = roles.colors[this.props.allAccess[i].accessLevel];
        roleName = this.props.allAccess[i].accessLevel;
      }
    }
    return { icon, iconColor, roleName };
  };

  handleOnPress = (areaId) => {
    if (this.props.disabled && areaId == this.props.model.areaId) {
      return;
    }
    this.props.onPress && this.props.onPress(areaId);
  };
  handleOnChildPress = (subAraId) => {
    this.props.onChildPress && this.props.onChildPress(subAraId);
  };

  componentDidUpdate() {
    // console.log('this.props.allAccess in AreaAccessSelectItem did update', this.props.allAccess)
    let { icon, iconColor, roleName } = this.updateRole();
    // check new props with previous state to prevent infinite loop.
    // apply changes if and only if data updated
    if (roleName != this.state.roleName) {
      this.setState({ icon, iconColor, roleName });
    }
  }

  render() {
    return (
      <View>
        <TouchableHighlight
          style={[
            {
              ...this.props.style,
              flex: 1,
              borderColor: Theme.COLORS.MUTED,
              borderBottomWidth: 1,
              height: 70,
              paddingVertical: 12,
              justifyContent: "center",
            },
            IS_WEB ? { borderRightWidth: 1 } : { borderLeftWidth: 1 },
          ]}
          underlayColor="#f2f2f2"
          onPress={() => this.handleOnPress(this.props.model.areaId)}
        >
          <View
            style={{
              flexDirection: "row-reverse",
              alignItems: "center",
            }}
          >
            <Text
              style={{
                flex: 1,
                color: this.state.iconColor,
              }}
            >
              {this.props.model.areaName}
              {"\r\n"}
              {this.props.model.areaId > 0 && (
                <Text style={{ fontSize: 10 }}>
                  {translate(`user.role.${this.state.roleName}`)}
                </Text>
              )}
            </Text>
            {!this.props.disabled && (
              <FontAwesomeIcon
                icon={this.state.icon}
                size={24}
                color={this.state.iconColor}
                style={{ marginHorizontal: 15 }}
              />
            )}
          </View>
        </TouchableHighlight>
        {this.props.model.subAreas && this.props.model.subAreas.length > 0 && (
          <View style={IS_WEB ? { marginRight: 12 } : { marginLeft: 12 }}>
            {this.props.model.subAreas.map((sub) => {
              if (Number(sub)) {
                sub = AreaHelper.findAreaById(this.allAreas, sub) || {};
              }
              var displayItem = "none";
              if (
                sub.accessLevelValue >= 1000 &&
                (!this.props.searchTerm ||
                  sub.areaName
                    .toLowerCase()
                    .indexOf(this.props.searchTerm.toLowerCase().trim()) >= 0)
              ) {
                displayItem = "flex";
              }
              return (
                <AreaAccessSelectItem
                  key={sub.areaId.toString()}
                  model={sub}
                  allAreas={[...this.allAreas]}
                  allAccess={this.props.allAccess}
                  onPress={() => this.handleOnChildPress(sub)}
                  onChildPress={(sub) => this.handleOnChildPress(sub)}
                  searchTerm={this.props.searchTerm}
                  style={{ display: displayItem }}
                />
              );
            })}
          </View>
        )}
      </View>
    );
  }
}

class RoleItem extends Component {
  handleOnPress = () => {
    this.props.onPress && this.props.onPress(this.props.role);
  };
  render() {
    var iconName = roles.icons[this.props.role] || roles.icons.none;
    var iconColor = roles.colors[this.props.role] || roles.colors.none;
    return (
      <TouchableHighlight
        style={{
          // flex: 1,
          backgroundColor: "#FFF",
          borderRadius: 10,
          marginBottom: 5,
          height: 50,
          // width: WIDTH * 0.7,
          padding: 12,
          justifyContent: "center",
          shadowColor: Theme.COLORS.BACKGROUND,
          shadowOffset: {
            width: 0,
            height: 2,
          },
          shadowOpacity: 0.3,
          shadowRadius: 6.65,
          elevation: 3,
        }}
        underlayColor="#f2f2f2"
        onPress={() => {
          this.handleOnPress();
        }}
      >
        <View
          style={{
            flexDirection: IS_WEB ? "row-reverse" : "row",
            alignItems: "center",
          }}
        >
          <FontAwesomeIcon
            icon={iconName}
            color={iconColor}
            size={24}
            style={{ marginLeft: 5 }}
          />
          <Text
            style={{
              flex: 1,
              textAlign: RIGHT,
              color: iconColor,
              marginHorizontal: 5,
            }}
          >
            {translate(`user.role.${this.props.role}`)}
          </Text>
        </View>
      </TouchableHighlight>
    );
  }
}

RoleItem.propTypes = {
  role: PropTypes.oneOf(["admin", "support", "member", "guest", "none"]),
};

const styles = StyleSheet.create({
  modalInsideWrapper: {
    padding: 10,
    borderRadius: 15,
    alignSelf: "center",
    width: "100%",
    // flex : 1
    // , width : Dimensions.get('screen').width * .8
  },
});

const mapStateToProps = (state) => {
  return {
    userReducer: state.UserReducer,
    areaReducer: state.AreaReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    SetMemberAccess: (
      userMemberId,
      areaId,
      areaUId,
      accessLevel,
      expireValue,
      expireUnit,
      accessToken,
      buildingId
    ) =>
      dispatch(
        Actions.SetMemberAccess(
          userMemberId,
          areaId,
          areaUId,
          accessLevel,
          expireValue,
          expireUnit,
          accessToken,
          buildingId
        )
      ),
    NotifyUserModified: (userId, accessToken) =>
      dispatch(Actions.NotifyUserModified(userId, accessToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserAccessScreen);
